<template>
  <div class="page">
    <a name="holdings"/>
    <p class="dustin preheader">
      Appendix A - Your Portfolio Holdings
    </p>
    <p class="dustin-title">
      {{portfolio.name}}
    </p>
    <p>
      As of {{ portfolio.holdings_as_of_date }}
    </p>

    <section class="section">

        <table class="table is-fullwidth">
          <thead class="has-text-centered">
            <th>Name</th>
            <th>Ticker</th>
            <th>Category</th>
            <th v-if="dollarsOrPercentagesChoice == 'dollars' || dollarsOrPercentagesChoice == ''">USD</th>
            <th v-if="dollarsOrPercentagesChoice == 'percentages'">Percentage</th>
            
          </thead>
          <tbody>
            <tr
              v-for="(entry, index) in holdings"
              v-bind:key="`${entry.id}-${index}`"
            >
              <td>{{entry.ticker.full_name || entry.ticker.company_name}}</td>
              <td>{{entry.ticker.symbol}}</td>
              <td>{{entry.ticker.benchmark_description}}</td>
              <td v-if="dollarsOrPercentagesChoice == 'dollars' || dollarsOrPercentagesChoice == ''">{{entry.dollars.toLocaleString('en-US', {style: 'currency', currency: 'USD', maximumFractionDigits: 0})}}</td>
              <td v-if="dollarsOrPercentagesChoice == 'percentages'">{{entry.percent_owned.toFixed(2)}}%</td>

              
            </tr>
          </tbody>
        </table>

    </section>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        ready: false,
      }
    },
    props: {
      portfolio: Object,
      dollarsOrPercentagesChoice: {
        type: String,
        default: 'dollars'
      }
    },
    computed: {
      holdings: function() {
        return this.portfolio.holdings.filter((itm) => {
          return itm.dollars > 0;
        })
      },
      portfolioValue: function() {
        return this.portfolio.holdings.reduce((acc, itm) => {
          console.log(this.portfolio);
          return acc + itm.dollars;
        }, 0);
      }
    },
    methods: {
        calculatePercentage: function(amount) {
          return (amount / this.portfolioValue) * 100;
      }
    }
  }
</script>

<style lang="css" scoped>
</style>
